import React, { useEffect,  useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ActivityDialogProps, ExpertiseAdded } from "../item/activityFeed/types";
import { qualificationTypesService, subjectsService } from "../../services";
import { AssessmentActivities, ExpertiseType, TeachingActivity } from "../../domain/SubjectModel";

const useStyles = makeStyles(() => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
}));

export const ExpertiseAddedDialog: React.FC<ActivityDialogProps> = ({
  activity,
  onClose,
}) => {
  const classes = useStyles();

  var body: ExpertiseAdded = JSON.parse(activity.activityMetaData);

  const [subjectLabel, setSubject] = useState<string>();
  const [qualType, setQualType] = useState<string>();

  useEffect(() => {
    subjectsService
      .get(body["subjectId"].toString(), {})
      .then((response) => { setSubject(response["label"] ?? "subject not known") });
     
    qualificationTypesService.getAll({})
      .then((qt) => { setQualType(qt.filter(e => e.id === body["qualificationTypeId"])[0]["description"] ?? "qual type not known") })   
    
     
   }, []);
  
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {activity.activityTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <div style={{ marginBottom: 15 }}>
          <Typography><strong>Created by:</strong></Typography>
          <Typography>{activity.createdByDisplayName}</Typography>
          <Typography><strong>Subject:</strong></Typography>
          <Typography>{subjectLabel}</Typography>
          <Typography><strong>Qualification Type:</strong></Typography>
          <Typography>{qualType}</Typography> 
        </div>
        <div style={{ marginBottom: 15 }}>
          <Typography><strong>Expertise Type:</strong></Typography>
          {body.expertiseType & ExpertiseType.Assessment ? <Typography>Assessment</Typography> : null}
          {body.expertiseType & ExpertiseType.Industry ? <Typography>Industry</Typography> : null }
          {body.expertiseType & ExpertiseType.Teaching ? <Typography>Teaching</Typography> : null}
        </div>
        {body.expertiseType & ExpertiseType.Assessment ?
          < div style={{ marginBottom: 15 }}> 
            <Typography><strong>Assessment experience:</strong></Typography>
            {body.selectedAssessmentActivities & AssessmentActivities.MarkingAssessments ? <Typography>Making assessment judgements</Typography> : null}
            {body.selectedAssessmentActivities & AssessmentActivities.StandardSettingAndAwardingQualifications ? <Typography>Standard setting and awarding qualifications</Typography> : null}
            {body.selectedAssessmentActivities & AssessmentActivities.DesigningAndDevelopingAssessments ? <Typography>Designing and developing assessments</Typography> : null}
            {body.selectedAssessmentActivities & AssessmentActivities.EvaluatingAssessments ? <Typography>Evaluating assessments or assessment approaches</Typography> : null}
          </div> : null
        }
        {body.expertiseType & ExpertiseType.Teaching ?
          < div style={{ marginBottom: 15 }}>
            <Typography><strong>Teaching experience:</strong></Typography>
            {body.teachingActivity & TeachingActivity.TeachingOrLecturing ? <Typography>Teaching or lecturing</Typography> : null}
            {body.teachingActivity & TeachingActivity.Training ? <Typography>Training</Typography> : null}
            {body.teachingActivity & TeachingActivity.EducationalManagement ? <Typography>Educational management</Typography> : null}
            {body.teachingActivity & TeachingActivity.TeacherTraining ? <Typography>Teaching training</Typography> : null}
          </div> : null
        }
        
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-expertiseAdded-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};
